import React, { useState } from 'react';
import Form from 'screens/shared/form';
import Icon from 'screens/shared/icon';
import CardBasic from 'screens/shared/card-basic';
import { Paper, Collapse } from '@mui/material';
import { getLanColor, _t } from 'utils';
import { VALIDATION } from 'constant';

export default ({
  lans = [],
  items: nics = [],
  onAdd,
  onEdit,
  selectToEdit,
  selectToDelete,
  deselectToEdit,
  isLimitExceeded,
}) => {
  const nic = {
    lan: '',
  };

  const [openCreateForm, setOpenCreateForm] = useState(false);

  const mapLanOptions = ({ id, properties }) => ([
    id,
    <span className="lan-selector-option">
      <Icon name="ethernet" style={{ backgroundColor: getLanColor(id) }} />
      {`LAN ${id} ${properties.name ? ` - ${properties.name}` : ''}`}
    </span>,
  ]);

  const lansOptions = lans.filter(({ id }) => !nics.find(({ lan }) => lan === id)).map(mapLanOptions);

  if (!nics.find(({ lan }) => lan === 'new')) {
    lansOptions.unshift(['new', _t('Create New LAN')]);
  }

  const nicFields = [
    {
      name: 'lan',
      type: 'dropdown',
      title: 'Select a LAN',
      options: [...lansOptions],
    },
  ];

  const validations = [
    {
      name: 'lan',
      type: VALIDATION.REQUIRED,
    },
  ];

  const onSave = ({ id = null, ...item }) => {
    if (id) {
      return onEdit({ ...item, id });
    }

    // if (item.lan === 'new') {
    //   let lan = 1;
    //   // eslint-disable-next-line no-unused-vars
    //   for (const e of lans) {
    //     // eslint-disable-next-line radix
    //     if (lan !== parseInt(e.id)) {
    //       lan = e.id;
    //       break;
    //     }
    //     lan++;
    //   }

    //   item.lan = lan;
    // }

    onAdd(item);
    return setOpenCreateForm(false);
  };

  return (
    <div className="add-box">
      <h3 className="screen-create-server-title">
        {'NICs '}
        {isLimitExceeded && (
          <span className="circle-button" onClick={() => setOpenCreateForm((s) => !s)}>
            <Icon name="plus" />
            {_t('Add')}
          </span>
        )}
      </h3>
      <Collapse in={openCreateForm} collapsedSize="0px">
        <Paper style={{ marginTop: 20 }}>
          {openCreateForm && (
            <Form
              fields={nicFields}
              fieldsValues={nic}
              onSubmit={onSave}
              onCancel={() => setOpenCreateForm(false)}
              validations={validations}
            />
          )}
        </Paper>
      </Collapse>
      <div className="cards">
        {nics.map((nicInner) => {
          const {
            id, lan, isEdit = false,
          } = nicInner;
          const { properties: { name = '' } = {} } = lans.find((e) => e.id === id.toString()) || {};
          return (
            <div key={id}>
              <Collapse in={isEdit} collapsedSize="0px">
                <Paper style={{ marginTop: 20 }}>
                  {isEdit && (
                    <Form
                      fields={nicFields}
                      fieldsValues={nicInner}
                      onSubmit={onSave}
                      onCancel={() => deselectToEdit(id)}
                    />
                  )}
                </Paper>
              </Collapse>
              {!isEdit && (
                <CardBasic
                  icon="ethernet"
                  iconFill={lan === 'new' ? '#3e393c' : getLanColor(lan)}
                  title={lan === 'new' ? 'New LAN' : `LAN ${lan} ${name ? ` - ${name}` : ''}`}
                  actionButtons={{
                    edit: () => selectToEdit(id),
                    delete: () => selectToDelete(id),
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
